import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { User, AuthState } from '../models/auth.model';
import { authStorage } from '../utils';

const initialState: AuthState = {
  user: authStorage.getUser<User>(),
  isAuthenticated: !!authStorage.getToken(),
  isLoading: false,
  error: null,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setUser: (state, action: PayloadAction<User | null>) => {
      state.user = action.payload;
      state.isAuthenticated = !!action.payload;
      state.error = null;
    },
    logout: (state) => {
      state.user = null;
      state.isAuthenticated = false;
      state.isLoading = false;
      state.error = null;
      authStorage.clearTokens();
    },
    clearError: (state) => {
      state.error = null;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
  },
});

export const { setUser, logout, clearError, setLoading } = authSlice.actions;
export default authSlice.reducer;
